import React, { useEffect } from 'react';
import PrivateRoute from '../PrivateRoute/PrivateRoute';
import routes from '../../routes';
import { Route, Switch, useLocation } from 'react-router-dom';
import usePrivileges, { hasPrivilege } from '../Util/usePrivileges';

interface Props {}

const MainRoutes: React.FunctionComponent<Props> = (props) => {
  const privileges = usePrivileges();

  let location = useLocation()

  useEffect(
    () => {
      // console.log('ddd', location);
    },
    [location]
  )

  const privateRoutes = routes
  .filter(
    (route) => (route.privileges ? hasPrivilege(privileges, route.privileges) : true) && route.privateComponent
  );

  const publicRoutes = routes
  .filter((route) => (route.privileges ? hasPrivilege(privileges, route.privileges) : true) && route.topComponent);

  return (
    <Switch>
      {publicRoutes
        .map((route) => {
          return (
          <Route key={`${route.path}-pub`} path={route.path} component={route.topComponent} />
        )})}
      {privateRoutes
        .map((route) => {
          return (
          <PrivateRoute key={`${route.path}-priv`} path={route.path} authenticatedComponent={route.privateComponent} />
        )})}
    </Switch>
  );
};

export default MainRoutes;
